import React from 'react';
import { VendorCtaSelectorProps } from './VendorCtaSelector';
import { Button } from '../VehicleCard/CtaGroup/CtaGroup.style';

const ContactDealerCta = ({
  ctaDetails,
  variant,
  vin,
  vehicleId,
  vehicleType,
  market,
  mainDealer,
}: VendorCtaSelectorProps) => {
  const { ctaDealerId, ctaContactButtonLabel } = ctaDetails;
  const digitalLeadsData = JSON.stringify({
    vehicleId,
    vehicleType,
    market,
    presetForm: 'contact-dealer',
    dealerId: mainDealer?.slice(3),
  });

  return (
    <Button
      variant={variant}
      key={`key_${ctaDealerId}-${vin}`}
      data-testid="contact-dealer"
      id="digital-leads"
      data-info={digitalLeadsData}
    >
      {ctaContactButtonLabel || 'Contact Dealer'}
    </Button>
  );
};

export default ContactDealerCta;
